//import thu vien trong react
import { useState,useEffect,useContext } from "react";
//import toast
import {toast } from "react-toastify";

//import context
import Context from '../../Store/Context';

import { useTranslation } from "react-i18next";

//call api
import { callApiCoinMarketV2 } from "../../CallApi/CallApiCoinGecko";
import { Link } from "react-router-dom";

//phan swiper
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Navigation } from 'swiper/modules';

import PopularArticle from "../../Data/PopularArticle.json";
import PopularArticleCpn from "../../Component/Home/Popular/PopularArticleCpn";

import EditorArticle from "../../Data/EditorArticle.json";
import EditorArtiCleCpn from "../../Component/Home/Popular/EditorArticleCpn";

import LastestArticle from "../../Data/LatestArticle.json";
import LatestArticleCpn from "../../Component/Home/Popular/LatestArticleCpn";

import Newsletters from "../../Data/Newsletters.json";
import NewslettersCpn from "../../Component/Home/Popular/NewslettersCpn";


function HomePage(){
    const [arr1,setArr1] = useState([]);
    const [arr2,setArr2] = useState([]);


    //loading khi gọi api
    const [loading,setLoading] = useState(true);

    const [state,dispatch] = useContext(Context);

    const { t } = useTranslation("translation");


    const apiConiMarket =()=>{
        return callApiCoinMarketV2({vs_currency:"usd",page:"1",per_page:"30"})
    }

    const buildDataCoinMarket = (res=[])=>{
        let arr1 = res.slice(0,10).map((item,index)=>item.id);
        let arr2 = res.slice(11,20).map((item,index)=>item.id);
 
        setArr1(arr1);
        setArr2(arr2);
      
    }
 
     const callApiAll = ()=>{
       Promise.all([apiConiMarket()])
       .then((res)=>{
         const [resCoinMarket] = res;
 
         buildDataCoinMarket(resCoinMarket.data);
       })
       .catch(()=>{
        toast.error("Error Api");
       })
       .finally(()=>{
        setLoading(false);
       })
     }
     
 
     useEffect(()=>{
       callApiAll();  
     },[])

    return (
    <>
        <div className={loading===true ? "loader":""} />  
            
        <main>
            
            {/* phan lastest articles */}
            <div className="LatestArticles_mainDiv__gtRPr">
                <div className="LatestArticles_componentDiv__yUTDU">
                    <div className="LatestArticles_topDiv__PDSF1">
                        <div className="CTADesignACarousel_carouselDiv__kVvkx">
                            <div
                                className="react-multi-carousel-list container-with-dots "
                                dir="ltr"
                            >
                                <ul
                                className="react-multi-carousel-track "
                                style={{
                                    transition: "none",
                                    overflow: "unset",
                                    transform: "translate3d(0px, 0px, 0px)"
                                }}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="LatestArticles_bottomDiv__QlwYx">
                        <div className="LatestArticles_leftDiv__YOHpq">
                            {/* title */}
                            <div className="LatestArticles_title__7HHfa">
                                <h2>Bài viết mới nhất</h2>
                            </div>
                             {/* title */}
                           
                           {/* thumbnail */}
                           <div className="LatestArticles_card__atqmi">
                                <a href="/education/what-is-defi-2-0/">
                                <div className="LatestArticles_thumbnailDiv__vH5Uq">
                                    <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}
                                    >
                                    <span
                                        style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: "100%"
                                        }}
                                    >
                                        <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271024%27%20height=%27576%27/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0
                                        }}
                                        />
                                    </span>
                                    <img
                                        rel="preload"
                                        alt="Discover the Future of Finance with DeFi 2.0!"
                                        src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FWhat_is_De_Fi_2_0_8448833296.jpg&w=2048&q=75"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        className="LatestArticles_image__E1hpu"
                                        style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                        objectFit: "cover"
                                        }}
                                    />
                                    </span>
                                </div>
                                <div className="LatestArticles_thumbnailMobileDiv__cldIK">
                                    <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}
                                    >
                                    <span
                                        style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: "100%"
                                        }}
                                    >
                                        <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271024%27%20height=%27576%27/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0
                                        }}
                                        />
                                    </span>
                                    <img
                                        rel="preload"
                                        alt="Discover the Future of Finance with DeFi 2.0!"
                                        src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FWhat_is_De_Fi_2_0_8448833296.jpg&w=2048&q=75"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        className="LatestArticles_image__E1hpu"
                                        style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                        objectFit: "cover"
                                        }}
                                    />
                                    </span>
                                </div>
                                <div className="LatestArticles_categoryDiv__D_nT_">Education</div>
                                <div className="LatestArticles_titleDiv__HPa3f">
                                    Discover the Future of Finance with DeFi 2.0!
                                </div>
                                <div className="LatestArticles_descriptionDiv___GEMO">
                                    Discover the evolution of decentralized finance with Coin
                                    Bureau's comprehensive guide to DeFi 2.0. Unlock insights into
                                    its financial innovations and potential benefits.
                                </div>
                                <div className="LatestArticles_inforDiv__wtwWp">
                                    <div className="undefined">16 Jan 2025</div>
                                </div>
                                </a>
                            </div>
                             {/* thumbnail */}
                        </div>
                        
                        <div className="LatestArticles_middleDiv__0FTC1">
                            <div className="LatestArticles_viewMoreDiv__RGX9i">
                                <Link to="/blog/">
                                <div className="LatestArticles_viewMore__Hwu0o">
                                    Tất cả bài viết mới nhất{" "}
                                    <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="LatestArticles_iconDiv__W3y_s"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                    <polyline points="12 5 19 12 12 19" />
                                    </svg>
                                </div>
                                </Link>
                            </div>
                            
                            <div className="LatestArticles_articlesDiv__CmF79">
                                {LastestArticle.slice(2,6).map(item=><LatestArticleCpn data={item} />)}
                            </div>
                            
                            <div className="LatestArticles_articlesTabletDiv__dkmmf">
                                {LastestArticle.slice(2,5).map(item=><LatestArticleCpn data={item} />)}
                            </div>
                        </div>
                        
                        <div className="LatestArticles_rightDiv__8dvav">
                        <div className="CTADesignA_ctaCardDiv__ztnxE">
                            <img
                            alt="coinbureau hub"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="CTADesignA_ctaBackgroundImage__fZUKK"
                            sizes="100vw"
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FSubscribe-to-our-Exclusive-CoinBureau-Hub.jpg&w=3840&q=75"
                            style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                objectFit: "cover",
                                color: "transparent"
                            }}
                            />
                            <div className="CTADesignA_ctaCardDetailsDiv__0t6YC">
                            <div className="CTADesignA_ctaTitleDiv__rpBZV">
                                Subscribe to our Exclusive Coin Bureau Club
                            </div>
                            <div
                                className="CTADesignA_ctaButtonDiv__hXs6r"
                                id="coin_bureau_club_id"
                                style={{ backgroundColor: "rgb(242, 200, 91)" }}
                            >
                                Subscribe
                            </div>
                            </div>
                        </div>
                        <div className="CTADesignA_ctaCardDiv__ztnxE">
                            <img
                            alt="coinbureau telegram group"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="CTADesignA_ctaBackgroundImage__fZUKK"
                            sizes="100vw"
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FJoin-our-exclusive-Telegram-Group.jpg&w=3840&q=75"
                            style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                objectFit: "cover",
                                color: "transparent"
                            }}
                            />
                            <div className="CTADesignA_ctaCardDetailsDiv__0t6YC">
                            <div className="CTADesignA_ctaTitleDiv__rpBZV">
                                Join our exclusive Telegram Group
                            </div>
                            <div
                                className="CTADesignA_ctaButtonDiv__hXs6r"
                                id="telegram_id"
                                style={{ backgroundColor: "rgb(34, 158, 217)" }}
                            >
                                Join Now
                            </div>
                            </div>
                        </div>
                        <div className="CTADesignA_ctaCardDiv__ztnxE">
                            <img
                            alt="coinbureau newsletter"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="CTADesignA_ctaBackgroundImage__fZUKK"
                            sizes="100vw"
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FSubscribe-to-our-Newsletter.jpg&w=3840&q=75"
                            style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                objectFit: "cover",
                                color: "transparent"
                            }}
                            />
                            <div className="CTADesignA_ctaCardDetailsDiv__0t6YC">
                            <div className="CTADesignA_ctaTitleDiv__rpBZV">
                                Subscribe to our Newsletter
                            </div>
                            <div
                                className="CTADesignA_ctaButtonDiv__hXs6r"
                                id="newsletter_id"
                                style={{ backgroundColor: "rgb(207, 130, 0)" }}
                            >
                                Subscribe
                            </div>
                            </div>
                        </div>
                        <div className="CTADesignA_ctaCardDiv__ztnxE">
                            <img
                            alt="coinbureau discord server"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="CTADesignA_ctaBackgroundImage__fZUKK"
                            sizes="100vw"
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FJoin-Our-Discord-Server.jpg&w=3840&q=75"
                            style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                objectFit: "cover",
                                color: "transparent"
                            }}
                            />
                            <div className="CTADesignA_ctaCardDetailsDiv__0t6YC">
                            <div className="CTADesignA_ctaTitleDiv__rpBZV">
                                Join Our Discord Server
                            </div>
                            <div
                                className="CTADesignA_ctaButtonDiv__hXs6r"
                                id="discord_id"
                                style={{ backgroundColor: "rgb(114, 137, 215)" }}
                            >
                                Join Now
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* phan lastest articles */}

            {/* phan coin */}
            <div className="PopularArticles_mainDiv__kBBDR">
            <div className="PopularArticles_componentDiv__SzJoL">

            {arr1.length>0?<gecko-coin-price-marquee-widget id="test1" vce-ready="false" locale="en" dark-mode={state.theme==="dark"?true:false} outlined="true" coin-ids={arr1.toString()} initial-currency="usd"></gecko-coin-price-marquee-widget>:<div></div>}
            {arr2.length>0?<gecko-coin-price-marquee-widget id="test2" vce-ready="false"  locale="en" dark-mode={state.theme==="dark"?true:false} outlined="true" coin-ids={arr2.toString()} initial-currency="usd"></gecko-coin-price-marquee-widget>: <div></div>}

            </div>
            </div>
            {/* phan coin */}


            {/* popular articles */}
            <div className="PopularArticles_mainDiv__kBBDR">
                <div className="PopularArticles_componentDiv__SzJoL">
                    <div className="PopularArticles_topDiv__gYCfp">
                        <div className="PopularArticles_title__BFUne">
                        <h2>Bài viết phổ biến</h2>
                        </div>
                        <div className="PopularArticles_viewMoreDiv__cIioj">
                        <Link to="/blog/popular">
                            <div className="PopularArticles_viewMore__LZLLJ">
                            Tất cả bài viết phổ biến{" "}
                            <svg
                                stroke="currentColor"
                                fill="none"
                                strokeWidth={2}
                                viewBox="0 0 24 24"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="PopularArticles_iconDiv__SiJtj"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line x1={5} y1={12} x2={19} y2={12} />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                            </div>
                        </Link>
                        </div>
                    </div>
                    <div className="PopularArticles_bottomDiv__1kNs8">

                        {PopularArticle.slice(0,3).map(item=><PopularArticleCpn data={item} />)}


                    </div>
                    <div className="customCarousel_productCarousel__0vmWw">
                        <div
                        className="customCarousel_productContainer__kOQKO"
                        id="DisplayFrame"
                        >

                        <Swiper
                            spaceBetween={30}
                            grabCursor={true}
                            loop={true}
                            parallax={true}
                            observer={true}
                            observeParents={true}
                        
                            slidesPerView={1.5}

                            // breakpoints={{...objBreakpoint}}
                        >

                            {PopularArticle.slice(0,3).map(item=><SwiperSlide><PopularArticleCpn data={item} /></SwiperSlide>)}


                            </Swiper>
                        </div>
                    </div>
                    <div className="PopularArticles_viewMoreBottomDiv__Je1zq">
                        <Link to="/blog/popular">
                        <div className="PopularArticles_viewMore__LZLLJ">
                            Tất cả bài viết phổ biến{" "}
                            <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="PopularArticles_iconDiv__SiJtj"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <line x1={5} y1={12} x2={19} y2={12} />
                            <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </div>
                        </Link>
                    </div>
                </div>
            </div>
             {/* popular articles */}


            {/* top deals */}

             {/* top deals */}

            {/* Editor’s Picks */}
            <div className="EditorsPicks_mainDiv__8FD_I">
            <div className="EditorsPicks_componentDiv__Ajp51">
            <div className="EditorsPicks_topDiv__VwN8w">
                <div className="EditorsPicks_title__1aKxP">
                <h2>Lựa chọn của biên tập viên</h2>
                </div>
                <div className="EditorsPicks_viewMoreDiv__O2Yp6">
                <Link to="/blog/editor">
                    <div className="EditorsPicks_viewMore__cOtNH">
                    Tất cả bài viết{" "}
                    <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="EditorsPicks_iconDiv__K6bHA"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <line x1={5} y1={12} x2={19} y2={12} />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                    </div>
                </Link>
                </div>
            </div>
            
            <div className="EditorsPicks_bottomDiv__z3vkJ">


                {EditorArticle.slice(0,3).map(item=> <EditorArtiCleCpn data={item} />)}

            </div>
            <div className="customCarousel_productCarousel__gPSpv">
                <div
                className="customCarousel_productContainer__GcWsa"
                id="DisplayFrame"
                >
                <Swiper
                            spaceBetween={30}
                            grabCursor={true}
                            loop={true}
                            parallax={true}
                            observer={true}
                            observeParents={true}
                        
                            slidesPerView={1.5}

                            // breakpoints={{...objBreakpoint}}
                        >

                            {EditorArticle.slice(0,3).map(item=><SwiperSlide><EditorArtiCleCpn data={item} /></SwiperSlide>)}


                            </Swiper>


                </div>
            </div>
            <div className="EditorsPicks_viewMoreBottomDiv__Qo4P6">
                <Link to="/blog/editor">
                <div className="EditorsPicks_viewMore__cOtNH">
                    tất cả bài viết{" "}
                    <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="EditorsPicks_iconDiv__K6bHA"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <line x1={5} y1={12} x2={19} y2={12} />
                    <polyline points="12 5 19 12 12 19" />
                    </svg>
                </div>
                </Link>
            </div>
            </div>
            </div>
            {/* Editor’s Picks */}

            {/* phan email */}
            <div className="Subscribe_mainDiv__rlkig">
                <div className="Subscribe_componentDiv__rw8c_">
                <div className="Subscribe_leftDiv__zyApV">
                    <div className="Subscribe_titleDiv__kbPwA">
                    Free Crypto Coverage Direct to Your Inbox
                    </div>
                    <div className="Subscribe_subtitleDiv__gXBe5">
                    Subscribe now to enjoy all the following benefits:
                    </div>
                    <div className="Subscribe_listDiv__00pXK">
                    <div className="Subscribe_icon__TKhGX">
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 16 16"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                        <path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                    </div>
                    <div className="Subscribe_point__OIhMt">
                        Fundamental Research – Blockchain project reviews
                    </div>
                    </div>
                    <div className="Subscribe_listDiv__00pXK">
                    <div className="Subscribe_icon__TKhGX">
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 16 16"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                        <path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                    </div>
                    <div className="Subscribe_point__OIhMt">
                        Use crypto more effectively with our Guides
                    </div>
                    </div>
                    <div className="Subscribe_listDiv__00pXK">
                    <div className="Subscribe_icon__TKhGX">
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 16 16"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                        <path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                    </div>
                    <div className="Subscribe_point__OIhMt">
                        Learn how to trade and create a crypto portfolio
                    </div>
                    </div>
                    <div className="Subscribe_listDiv__00pXK">
                    <div className="Subscribe_icon__TKhGX">
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 16 16"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                        <path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                    </div>
                    <div className="Subscribe_point__OIhMt">
                        The best evergreen crypto content on the web
                    </div>
                    </div>
                    <div className="Subscribe_listDiv__00pXK">
                    <div className="Subscribe_icon__TKhGX">
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 16 16"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                        <path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                    </div>
                    <div className="Subscribe_point__OIhMt">
                        It’s all free and delivered direct to you
                    </div>
                    </div>
                    <div className="Subscribe_subscribeBox__epgu9">
                    <div className="Subscribe_emailBox__0V3iw">
                        <input
                        className="Subscribe_emailInput__nUtN_"
                        type="text"
                        placeholder="Enter your email"
                        name="email"
                        defaultValue=""
                        />
                    </div>
                    <div className="Subscribe_submitBtn__DhR_E">Subscribe</div>
                    </div>
                    <div style={{ height: 20 }} />
                </div>
                <div className="Subscribe_rightDiv__Wp1ob">
                    <img
                    alt="Coin Bureau Newsletter"
                    loading="lazy"
                    width={500}
                    height={500}
                    decoding="async"
                    data-nimg={1}
                    src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FNewsletter.png&w=1080&q=75"
                    style={{ color: "transparent", maxWidth: "100%" }}
                    />
                </div>
                </div>
            </div>
            {/* phan email */}

            {/* Explore By Category */}
            <div className="ExploreCategory_mainDiv__Jei94">
            <div className="ExploreCategory_desktopTabletView__shiDt">
            <div className="normalCategory_mainDiv__STRAV">
                <div className="normalCategory_componentDiv__YT1FL">
                <div className="normalCategory_titleDiv__btaPE">
                    <h2>Khám phá theo danh mục</h2>
                </div>
                <div className="normalCategory_cardsDiv__YuxIG">
                    <a href="/category/news/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="News"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FNews%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">news</div>
                    </div>
                    </a>
                    <a href="/category/review/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Review"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FReview%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">review</div>
                    </div>
                    </a>
                    <a href="/category/education/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Education"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FEducation%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">education</div>
                    </div>
                    </a>
                    <a href="/category/defi/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Defi"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FDefi%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">defi</div>
                    </div>
                    </a>
                    <a href="/category/guides/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Guides"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FGuides%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">guides</div>
                    </div>
                    </a>
                    <a href="/category/trading/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Trading"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FTrading%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">trading</div>
                    </div>
                    </a>
                    <a href="/category/adoption/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Adoption"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FAdoption%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">adoption</div>
                    </div>
                    </a>
                    <a href="/category/mining/">
                    <div className="normalCategory_singleCard__kC0pd">
                        <div className="normalCategory_thumbnailDiv__sMNC7">
                        <img
                            alt="Mining"
                            loading="lazy"
                            width={400}
                            height={225}
                            decoding="async"
                            data-nimg={1}
                            src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fpublic%2FMining%202.jpg&w=828&q=75"
                            style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                            }}
                        />
                        </div>
                        <div className="normalCategory_category__8Leau">mining</div>
                    </div>
                    </a>
                </div>
                </div>
            </div>
            </div>
            <div className="ExploreCategory_mobileView__5HYfP">
            <div className="carouselCategory_mainDiv__R8Z73">
                <div className="carouselCategory_componentDiv__AKe5b">
                <div className="carouselCategory_titleDiv__axAfg">
                    <h2>Khám phá theo danh mục</h2>
                </div>
                <div className="carouselCategory_cardsDiv__9ChXa">
                    <div
                    className="react-multi-carousel-list container-with-dots "
                    dir="ltr"
                    >
                    <ul
                        className="react-multi-carousel-track "
                        style={{
                        transition: "none",
                        overflow: "unset",
                        transform: "translate3d(0px, 0px, 0px)"
                        }}
                    />
                    </div>
                </div>
                </div>
            </div>
            </div>
            </div>
             {/* Explore By Category */}

            {/* Newsletters */}
            <div className="Newsletters_mainDiv__R7yYt">
                <div className="Newsletters_componentDiv__0uH4f">
                    <div className="Newsletters_topDiv__JDYL_">
                        <div className="Newsletters_title__pC_Vj">
                        <h2>Bản tin</h2>
                        </div>
                        <div className="Newsletters_viewMoreDiv__vWOG7">
                        <a href="/newsletters/">
                            <div className="Newsletters_viewMore__XcY8a">
                            Tất cả các bản tin{" "}
                            <svg
                                stroke="currentColor"
                                fill="none"
                                strokeWidth={2}
                                viewBox="0 0 24 24"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="Newsletters_iconDiv__uGGHn"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line x1={5} y1={12} x2={19} y2={12} />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                            </div>
                        </a>
                        </div>
                    </div>
                    <div className="Newsletters_bottomDiv__068L3">
                        {Newsletters.slice(0,3).map(item=> <NewslettersCpn data={item} />)}
                    </div>
                    <div className="customCarousel_productCarousel__k02q8">
                        <div
                        className="customCarousel_productContainer__iqVdQ"
                        id="DisplayFrame"
                        >
                            {/* <a href="/newsletters/russia-bitcoin/">
                                {" "}
                                <div className="customCarousel_cardDiv__HU54Z">
                                <div>
                                    <div className="customCarousel_thumbnailDiv__be2hP">
                                    <img
                                        alt="Russia is Diving Into Bitcoin! What it Means"
                                        loading="lazy"
                                        width={1024}
                                        height={576}
                                        decoding="async"
                                        data-nimg={1}
                                        className="customCarousel_image__S4nv9"
                                        src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FRussia_update_2e080c7ca5.jpg&w=2048&q=50"
                                        style={{
                                        color: "transparent",
                                        maxWidth: "100%",
                                        height: "auto"
                                        }}
                                    />
                                    </div>
                                    <div className="customCarousel_detailsDiv__gjeK1">
                                    <div className="customCarousel_titleDiv__FoFgV">
                                        Russia is Diving Into Bitcoin! What it Means
                                    </div>
                                    </div>
                                </div>
                                <div className="customCarousel_lowerDiv__gJIa9">
                                    <div className="customCarousel_dateDiv__3XEGT">14 Jan 2025</div>
                                </div>
                                </div>
                            </a>
                            <a href="/newsletters/crypto-mistakes-to-avoid/">
                                {" "}
                                <div className="customCarousel_cardDiv__HU54Z">
                                <div>
                                    <div className="customCarousel_thumbnailDiv__be2hP">
                                    <img
                                        alt="These Mistakes Could Cost You MILLIONS!"
                                        loading="lazy"
                                        width={1024}
                                        height={576}
                                        decoding="async"
                                        data-nimg={1}
                                        className="customCarousel_image__S4nv9"
                                        src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FBull_Market_Mistakes_3d7ea2e388.jpg&w=2048&q=50"
                                        style={{
                                        color: "transparent",
                                        maxWidth: "100%",
                                        height: "auto"
                                        }}
                                    />
                                    </div>
                                    <div className="customCarousel_detailsDiv__gjeK1">
                                    <div className="customCarousel_titleDiv__FoFgV">
                                        These Mistakes Could Cost You MILLIONS!
                                    </div>
                                    </div>
                                </div>
                                <div className="customCarousel_lowerDiv__gJIa9">
                                    <div className="customCarousel_dateDiv__3XEGT">06 Jan 2025</div>
                                </div>
                                </div>
                            </a>
                            <a href="/newsletters/2025-crypto-predictions/">
                                {" "}
                                <div className="customCarousel_cardDiv__HU54Z">
                                <div>
                                    <div className="customCarousel_thumbnailDiv__be2hP">
                                    <img
                                        alt="Our 2025 Predictions: Don’t Miss This!"
                                        loading="lazy"
                                        width={1024}
                                        height={576}
                                        decoding="async"
                                        data-nimg={1}
                                        className="customCarousel_image__S4nv9"
                                        src="https://coinbureau.com/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2F2025_Predictions_44e50b2e98.jpg&w=2048&q=50"
                                        style={{
                                        color: "transparent",
                                        maxWidth: "100%",
                                        height: "auto"
                                        }}
                                    />
                                    </div>
                                    <div className="customCarousel_detailsDiv__gjeK1">
                                    <div className="customCarousel_titleDiv__FoFgV">
                                        Our 2025 Predictions: Don’t Miss This!
                                    </div>
                                    </div>
                                </div>
                                <div className="customCarousel_lowerDiv__gJIa9">
                                    <div className="customCarousel_dateDiv__3XEGT">30 Dec 2024</div>
                                </div>
                                </div>
                            </a> */}

                        <Swiper
                            spaceBetween={30}
                            grabCursor={true}
                            loop={true}
                            parallax={true}
                            observer={true}
                            observeParents={true}
                        
                            slidesPerView={1.5}

                            // breakpoints={{...objBreakpoint}}
                        >

                            {Newsletters.slice(0,3).map(item=><SwiperSlide><NewslettersCpn data={item} /></SwiperSlide>)}


                            </Swiper>
                        
                        </div>
                    </div>
                    <div className="Newsletters_viewMoreBottomDiv__fjhpF">
                        <a href="/newsletters/">
                        <div className="Newsletters_viewMore__XcY8a">
                            Tất cả các bản tin{" "}
                            <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="Newsletters_iconDiv__uGGHn"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <line x1={5} y1={12} x2={19} y2={12} />
                            <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </div>
                        </a>
                    </div>
                </div>
            </div>
            {/* Newsletters */}

        </main>
    </>
    )
}
export default HomePage;